<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title" style="margin-top:9px">Add Gateway</h4>
  <i style="z-index: 1"
     class="bi bi-x-lg text-danger"
     color="warn"
     (click)="onClose()"
     title="Close"></i>
</div>
<div>

  <div class="modal-body text-grey">
    <form name="addGatewayForm"
        [formGroup]="addGatewayForm"
        (ngSubmit)="onSubmit(addGatewayForm)"
        autocomplete="off"
        spellcheck="false" style="padding:6px;">
    <mat-form-field style="width: 95%">
      <mat-label>Gateway Name</mat-label>
      <input matInput style="font-size: 0.875em;"
             maxlength="20"
             placeholder="Gateway Name"
             formControlName="addGatewayName"
             title="Gateway name can be of maximum 20 characters containing alphabets, numbers, _ -" />
      <mat-error *ngIf="
          addGatewayForm.get('addGatewayName').touched &&
          addGatewayForm.get('addGatewayName').errors?.required
        ">Required</mat-error>
      <mat-error *ngIf="addGatewayForm.get('addGatewayName').errors?.pattern">Enter valid gateway name.</mat-error>
    </mat-form-field>

    <mat-form-field style="width: 95%">
      <mat-label>Gateway IP</mat-label>
      <input matInput style="font-size: 0.875em;"
             maxlength="15"
             placeholder="Gateway IP"
             formControlName="addGatewayIP" />
      <mat-error *ngIf="
          addGatewayForm.get('addGatewayIP').touched &&
          addGatewayForm.get('addGatewayIP').errors?.required
        ">Required</mat-error>
      <mat-error *ngIf="
          addGatewayForm.get('addGatewayIP').touched &&
          addGatewayForm.get('addGatewayIP').errors?.pattern
        ">Enter Valid IP</mat-error>
    </mat-form-field>

    <mat-form-field style="width: 95%">
      <mat-label>Gateway Port</mat-label>
      <input matInput style="font-size: 0.875em;"
             placeholder="Gateway Port"
             formControlName="addGatewayPort" />
      <mat-error *ngIf="
          addGatewayForm.get('addGatewayPort').touched &&
          addGatewayForm.get('addGatewayPort').errors?.required
        ">Required</mat-error>
      <mat-error *ngIf="
          addGatewayForm.get('addGatewayPort').touched &&
          addGatewayForm.get('addGatewayPort').errors?.pattern
        ">Enter Valid Port</mat-error>
    </mat-form-field>

    <div class="modal-footer">
      <button type="button"
              class="btn btn-outline-secondary"
              (click)="onClose()">
        Close
      </button>
      <button type="submit"
              class="btn btn-primary"
              [disabled]="!addGatewayForm.valid"
              [title]="!addGatewayForm.valid ? 'Submit button will be enabled when all required fields are filled' : 'New gateway will be added on submitting the form.'">
        Submit
      </button>
    </div>
  </form>
  </div>
  
</div>
